import React from 'react';
import { ENUM_DEAL_STATUS, ENUM_EXPLORE_CARD_STATUS } from 'utils/enums';

type StatusColorProps = {
  status: ENUM_DEAL_STATUS | ENUM_EXPLORE_CARD_STATUS;
  disableBgColor?: boolean;
  className?: string;
  wrapperClassName?: string;
};

const badgeColor = {
  [ENUM_DEAL_STATUS.Expired]: 'text-[#E60A2B] border-[#E60A2B] bg-[#E60A2B]/10',
  [ENUM_DEAL_STATUS.Upcoming]: 'text-[#B26800] border-[#B26800] bg-[#B26800]/10',
  [ENUM_DEAL_STATUS.Active]: 'text-[#3FB827] border-[#3FB827] bg-[#3FB827]/10',
  [ENUM_EXPLORE_CARD_STATUS.PROMO]: 'text-[#3FB827] border-[#3FB827] bg-gray-2'
};

const StatusColor: React.FC<StatusColorProps> = ({
  status,
  disableBgColor = false,
  className,
  wrapperClassName
}) => {
  return (
    <span
      className={`inline-flex items-center justify-center border  p-1 px-4 rounded-2xl ${
        badgeColor?.[status as keyof typeof badgeColor] ?? 'text-purple] bg-purple/10'
      } ${disableBgColor ? '!bg-transparent !px-0' : ''} ${wrapperClassName}`}>
      <span className={`text-center capitalize-first font-medium ${className}`}>{status}</span>
    </span>
  );
};

export default StatusColor;
